import { CheckCircle2, Clock } from "lucide-react";
import { HeroBuyButton } from "../common/ServiceOrderBundle";
import { ALLIN_DEADLINE, ALLIN_FEATURES, ALLIN_PLANS } from "../../data/funnelContent";

const daysLeft = () => Math.max(0, Math.ceil((ALLIN_DEADLINE - new Date()) / 86400000));

const PlanCard = ({ plan, expired }) => (
  <div data-testid={`allin-plan-${plan.id}`} className={`relative rounded-2xl border p-6 sm:p-7 flex flex-col transition-transform duration-300 hover:-translate-y-1 ${plan.recommended ? "border-[#a855f7] bg-[#a855f7]/10" : "border-white/10 bg-white/[0.03]"}`}>
    {plan.recommended && <span className="absolute -top-3 left-6 px-3 py-1 text-[10px] font-black uppercase tracking-wider bg-[#a855f7] text-white rounded-full">Najobľúbenejšie</span>}
    <h3 className="text-2xl font-black text-white font-['Cabinet_Grotesk']">{plan.name}</h3>
    <p className="mt-3 text-4xl font-black text-white font-['JetBrains_Mono']">€{plan.price}<span className="text-base text-white/50">{plan.unit}</span></p>
    <p className="mt-3 text-sm text-white/70 flex-1">{plan.note}</p>
    <div className="mt-6">
      {expired ? <p className="text-sm text-red-300" data-testid="allin-expired">Ponuka skončila.</p> : <HeroBuyButton packageId={plan.id} priceEur={plan.price} label={`Objednať za €${plan.price}`} testid={`allin-buy-${plan.id}`} />}
    </div>
  </div>
);

export const AllInOffer = () => {
  const days = daysLeft();
  return (
    <section id="ponuka" className="max-w-6xl mx-auto px-5 sm:px-8 py-16 scroll-mt-20" data-testid="allin-offer">
      <div className="inline-flex items-center gap-2 px-3 py-1.5 mb-5 rounded-full bg-amber-500/15 border border-amber-500/40 text-amber-300 text-xs font-bold" data-testid="allin-countdown">
        <Clock className="w-3.5 h-3.5" /> Ponuka platí do 31. 12. 2026 · zostáva {days} dní
      </div>
      <h2 className="text-3xl sm:text-4xl font-black text-white font-['Cabinet_Grotesk'] mb-3">Všetko v jednom 2026</h2>
      <p className="text-white/60 mb-8 text-sm sm:text-base">8 nástrojov, ktoré samostatne stoja €273 mesačne, v jednom pláne.</p>
      <div className="grid lg:grid-cols-[1.1fr_1fr_1fr] gap-6">
        <ul className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 space-y-2.5" data-testid="allin-features">
          {ALLIN_FEATURES.map((f) => (
            <li key={f} className="flex gap-2 text-sm text-white/85"><CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />{f}</li>
          ))}
        </ul>
        {ALLIN_PLANS.map((p) => <PlanCard key={p.id} plan={p} expired={days === 0} />)}
      </div>
    </section>
  );
};
